import { urbanColors } from "@urbaninstitute/dataviz-components/utils";

export const MAP_COLORS = [
  urbanColors.blue_shade_lightest,
  urbanColors.blue_shade_light,
  urbanColors.blue,
  urbanColors.blue_shade_darker,
  urbanColors.blue_shade_darkest
];

export const CHART_COLORS_SIMPLE = [urbanColors.yellow, urbanColors.space_gray, urbanColors.blue];

// export const CHART_COLORS_SUBCATS = [
//   urbanColors.blue_shade_lightest,
//   urbanColors.blue_shade_lighter,
//   urbanColors.blue,
//   urbanColors.blue_shade_dark,
//   urbanColors.blue_shade_darker,
//   urbanColors.yellow,
//   urbanColors.yellow_shade_lighter
// ];
// Paired by drug: buprenorphine (blue), naltrexone (yellow), naloxone (gray)
export const CHART_COLORS_SUBCATS = [
  urbanColors.yellow,
  urbanColors.yellow_shade_darker,
  urbanColors.space_gray_shade_lighter,
  urbanColors.space_gray,
  urbanColors.blue,
  urbanColors.blue_shade_darker
];

// Paired by drug: buprenorphine (blue), naltrexone (yellow), naloxone (gray)
export const CHART_COLORS_GROUPED = [
  [urbanColors.yellow, urbanColors.space_gray, urbanColors.blue],
  [
    urbanColors.yellow_shade_darker,
    urbanColors.space_gray_shade_lighter,
    urbanColors.blue_shade_darker
  ]
];
